export default function nextFrame (callback) {
  return new Promise(resolve => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(time => {
        resolve(callback(time));
      });
    });
  });
}
